import dayjs from 'dayjs';

import type { ExperienceDurationDescription } from 'app/typings/core/common/experiences/enum/experienceDurationDescription';
import { pluralize } from 'app/utils/strings';

import type { GroupedHotelActivities, HotelActivity } from '../../_types';

export const getActivityPath = (
  activity: HotelActivity,
  isLegacy: boolean
): string =>
  isLegacy ? `/activities/legacy/${activity.id}` : `/activities/${activity.id}`;

export const groupActivitiesByType = (
  activities: HotelActivity[]
): GroupedHotelActivities => ({
  alwaysIncluded: activities.filter((a) => a.isAlwaysIncludedWithNight),
  others: activities.filter((a) => !a.isAlwaysIncludedWithNight),
});

const formatDuration = (
  duration?: number,
  durationDescription?: ExperienceDurationDescription
): string | null => {
  if (duration === undefined || !durationDescription) {
    return null;
  }

  const durationMap: Record<ExperienceDurationDescription, string> = {
    MINUTE: pluralize(duration, 'min', 'mins'),
    HOUR: pluralize(duration, 'hour', 'hours'),
    HALF_DAY: 'half day',
    DAY: pluralize(duration, 'day', 'days'),
  };

  return durationMap[durationDescription];
};

export const formatExperienceName = (activity: HotelActivity): string => {
  const parts: string[] = [];

  if (activity.category?.name) {
    parts.push(activity.category.name);
  }

  if (activity.brand) {
    parts.push(activity.brand);
  }

  const duration = formatDuration(
    activity.duration,
    activity.durationDescription
  );

  if (duration) {
    parts.push(duration);
  }

  if (activity.time) {
    parts.push(dayjs(`1970-01-01T${activity.time}`).format('HH:mm'));
  }

  if (activity.location) {
    parts.push(activity.location);
  }

  return parts.join(' • ');
};
